import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreUiDirectivesModule, CoreUIIconsModule, CoreUiInputsModule } from 'lib-klab-core-ui';
import { MicrosUISecurityModule } from 'lib-klab-micros-auth-ui';
import { LoginPageComponent } from './pages/login/login.component';
import { RecoverPasswordPageComponent } from './pages/recover-password/recover-password.component';

@NgModule({
    declarations: [LoginPageComponent, RecoverPasswordPageComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CoreUiInputsModule,
        CoreUIIconsModule,
        CoreUiDirectivesModule,
        MicrosUISecurityModule,
    ],
    exports: [LoginPageComponent, RecoverPasswordPageComponent],
})
export class LibKlabAuthUiModule { }
